import { on } from 'delegated-events'

const form = document.querySelector('.contact-form')

const fn = {

    init: () => {
        on('change', '.feedback-form-dropdown select', fn.handleComments)
    },

    handleComments: (e) => {
        const value = e.target.value

        const selectedOption = e.target.options[e.target.selectedIndex]
        const title = selectedOption.textContent.trim() // Get the title from the selected option
        const dataOptions = e.target.getAttribute('data-options')

        let dataLabel = ''
        if (dataOptions) {
            const jsonData = JSON.parse(dataOptions)
            if (jsonData[title]) {
                dataLabel = jsonData[title].DataLabel
            }
        }

        const comments = form.querySelector('.field.feedback-form-comments')

        if (dataLabel) {
            const textarea = comments.querySelector('textarea')
            textarea.setAttribute('placeholder', dataLabel + ' *')
        }

        if (comments.classList.contains('hidden')) {
            comments.classList.remove('hidden')
        }
    }

}

export default {
    can: () => document.querySelector('.contact-form'),
    run: fn.init,
}
